<template>
  <div>
    <a-table ref="table" :scroll="{ x: 1200 }" :pagination="false" row-key="id" :columns="columns" :data-source="dataSource" size="middle">
      <span slot="customerTitle" slot-scope="text, record">
        <a-tooltip placement="top" :title="record.name">
          <a class="custom-link" :href="taskLink(record.id)" target="_blank"> {{ record.name }} </a>
        </a-tooltip>
      </span>
      <span slot="requirement_name" slot-scope="text, record">
        <a-tooltip placement="top" :title="record.requirement_name">
          <a class="custom-link" :href="reqLink(record.requirement_id)" target="_blank"> {{ record.requirement_name }} </a>
        </a-tooltip>
      </span>
      <span slot="status" slot-scope="text, record">
        <a-tag :color="taskStatus[record.status].color">{{ taskStatus[record.status].label }}</a-tag>
      </span>
      <span slot="version" slot-scope="text, record">
        <a v-if="record.version_title !== null">{{ record.version_title }}</a>
        <span v-else>--</span>
      </span>
      <span slot="priority" slot-scope="text, record">
        <a-tag :color="taskPrioritys[record.priority].color"> {{ taskPrioritys[record.priority].label }} </a-tag>
      </span>
      <template slot="handlers" slot-scope="text, record">
        <user-profiles :value="[record.handlers.map(item => item.id)]" avatar />
      </template>
    </a-table>
  </div>
</template>

<script>
import { taskStatus, taskPrioritys } from '@/utils/dictionary';

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 92,
    customRender: (_text, _row) => {
      return 'TS-' + _text;
    }
  },
  {
    title: '标题',
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
    width: 300,
    scopedSlots: { customRender: 'customerTitle' }
  },
  {
    title: '父需求',
    dataIndex: 'requirement_name',
    key: 'requirement_name',
    ellipsis: true,
    width: 300,
    scopedSlots: { customRender: 'requirement_name' }
  },
  {
    width: 160,
    ellipsis: true,
    title: '所属迭代',
    dataIndex: 'version_title',
    customRender: text => text || '--'
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    width: 100,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '优先级',
    dataIndex: 'priority',
    key: 'priority',
    width: 80,
    scopedSlots: { customRender: 'priority' }
  },
  {
    title: '处理人',
    width: 120,
    ellipsis: true,
    dataIndex: 'handlers',
    scopedSlots: { customRender: 'handlers' }
  },
  {
    title: '开始时间',
    width: 120,
    dataIndex: 'start_time',
    customRender: text => text || '--'
  },
  {
    title: '结束时间',
    width: 120,
    dataIndex: 'end_time',
    customRender: text => text || '--'
  }
];
export default {
  props: {
    dataSource: {
      type: [Array],
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      columns,
      taskStatus,
      taskPrioritys
    };
  },
  computed: {
    taskLink() {
      return id => {
        const route = this.$router.resolve({
          name: 'page:project:task:detail',
          query: { taskId: id }
        });
        return route.href;
      };
    },
    reqLink() {
      return id => {
        const route = this.$router.resolve({
          name: 'page:project:story:detail',
          query: { storyId: id }
        });
        return route.href;
      };
    }
  }
};
</script>

<style lang="less" scoped>
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}

.custom-link:hover {
  color: #1890ff;
}
</style>
